import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Ratings(props) {
  return (
    <section className="tekrevol__ratings overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="mt-auto mb-auto rat-outer"
          >
            <div className="rat-wrap">
              <span>5M</span>
              <p>
                Number of <br className="d-sm-block d-none" />
                downloads
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="mt-auto mb-auto rat-outer"
          >
            <div className="rat-wrap">
              <span>4.8</span>
              <p>
                Ratings <br className="d-sm-block d-none" />
                of apps
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="mt-auto mb-auto rat-outer"
          >
            <div className="rat-wrap">
              <span>25</span>
              <p>
                Number <br className="d-sm-block d-none" />
                of exits
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ratings;
